<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="options"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    /**
     * Allows the setting of payment request's status from a list of
     * human readable options, and through extension any business logic
     * additionally required when this is changed
     */
    export default {
        name: 'ies-paymentRequestStatus',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                options: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.setOptions();
            if (!this.field.value){
                this.viewValue = 45;
            }
        },
        methods: {
            setOptions:function(){
                var options = [];
                options.push({ text: 'Payment Due', value: 45 });
                options.push({ text: 'Payment Complete', value: 46 });
                options.push({ text: 'Request Cancelled', value: 47 });
                this.options = options;
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
